/** 投标总览 — 蓝 + 琥珀双色系 */
export const BLUE = {
  primary: '#1a6fd4',
  dark: '#0d4a8f',
  mid: '#3d8ee8',
  light: '#6eb0f5',
  pale: '#d6e8fb',
  bg: '#f0f6fd',
  border: '#c5ddf5',
  text: '#1e3a5f',
  muted: '#6b8aad',
};

export const AMBER = {
  primary: '#d97706',
  dark: '#92400e',
  mid: '#f59e0b',
  light: '#fbbf24',
  pale: '#fef3c7',
  bg: '#fffbeb',
  border: '#fde68a',
};

export const LIST_SIZE = 10;
export const LIST_COLS = 1;
export const FEED_SIZE = 7;
export const ACTIVITY_SIZE = 10;

export const CHART_COLORS = [
  '#1a6fd4', '#d97706', '#3d8ee8', '#f59e0b', '#6eb0f5', '#fbbf24',
];

export const MODULE_THEME = {
  info: {accent: BLUE.primary, accentBg: BLUE.pale, icon: 'md-analytics'},
  work: {accent: BLUE.dark, accentBg: BLUE.bg, icon: 'md-hammer'},
  open: {accent: AMBER.primary, accentBg: AMBER.pale, icon: 'md-clipboard'},
};

export function chartColor(index) {
  return CHART_COLORS[index % CHART_COLORS.length];
}
